import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-vendor',
  templateUrl: './add-vendor.component.html',
  styleUrls: ['./add-vendor.component.css']
})
export class AddVendorComponent implements OnInit {

  vendorForm: any | FormGroup
  cid:any
  formSubmit: boolean = false;

  documents:any = []
  geoAddress:any = {
    "slNo": "",
    "name": "",
    "phone1": "",
    "phone2": "",
    "email": "",
    "latitude": "",
    "longitude": "",
    "address": "",
    "postCode": "",
    "isDefault": true,
    "type": "",
    "state": "",
    "landmark": "",
    "city": "",
    "town": "",
    "district": ""
  }

  keyValueList:any = []


  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.vendorForm = this.fb.group({
      name: [''],
      code: [''],
      image: [''],
      type: [''],
      contactPhone: [''],
      contactEmail: [''],
      contactName: [''],
      description: ['']
    })
    this.predefinedParameter()
  }

  imageButtonClick(){
    document.getElementById("imageInput")?.click()
  }

  onChange(event: any) {
    this.onUpload(event.target.files[0])
  }

  onUpload(file: any) {
    this.generic_service.uploadImage(file).subscribe(
      (event: any) => {
        this.vendorForm.patchValue({image: event.response});
      }
    );
  }

  imageRemove(){
    this.vendorForm.patchValue({image: ""})
  }

  docButtonClick(){
    document.getElementById("DocInput")?.click()
  }

  onChangeDoc(event: any) {
    console.log(event)
    this.onUploadDoc(event.target.files[0])
  }

  onUploadDoc(file: any) {
    console.log(file)
    let obj:any = {
      "name": file.name,
      "type": file.type,
      "url": ""
    }
    console.log(obj)
    this.generic_service.uploadImage(file).subscribe(
      (event: any) => {
        obj.url = event.response;
        this.documents.push(obj)
        console.log(this.documents)

      }
    );
  }

  predefinedParameter(){
    this.generic_service.predefinedParameter('VENDOR').subscribe(
      (response:any)=>{
        console.log(response)
        for(let i=0; i<response.response.length; i++){
          this.keyValueList.push(
            {
              boxType: response.response[i].boxType,
              key: response.response[i].name,
              possibleValue: response.response[i].possibleValue,
              value: ""
            }
          )
        }
        console.log(this.keyValueList)
      },
      (err:any)=>{
          console.log(err)
      }
    )
  }

  // get documentArray(){
  //   return this.vendorForm.get('documents') as FormArray;
  // }

  // addDocumentArray(){
  //   let arr = this.fb.group({
  //     name: [''],
  //     type: [''],
  //     url: [''],
  //   })
  //   this.documentArray.push(arr)
  // }

  addVendor(){
    this.formSubmit = true;
    // if(!this.vendorForm.valid){
    //   return
    // }

    for(var i = 0; i < this.keyValueList.length; i++){
      delete this.keyValueList[i].boxType
      delete this.keyValueList[i].possibleValue
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.vendorForm.get('description').value,
      "vendorMasterId": 0,
      "code": this.vendorForm.get('code').value,
      "name": this.vendorForm.get('name').value,
      "contactPhone": this.vendorForm.get('contactPhone').value,
      "contactEmail": this.vendorForm.get('contactEmail').value,
      "contactName": this.vendorForm.get('contactName').value,
      "documents": this.documents,
      "image": this.vendorForm.get('image').value,
      "keyValueList": this.keyValueList,
      "geoAddress": this.geoAddress,
      "statusList": [
        {
          "userId": 0,
          "vendorMasterStatus": "APPLIED",
          "updatedDate": 0,
          "note": ""
        }
      ],
      "latestStatus": "APPLIED",
      "latestStatusDate": 0,
      "size": "",
      "type": this.vendorForm.get('type').value,
      "cid": 0
    }
    console.log(body)
    this.generic_service.addVendor(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.vendorForm.reset()
        this.vendorForm.patchValue({image: ""})
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

}

